<p></p>
<div class="container">
  <div class="row">
    <div class="col">
        <p></p>
        <mat-card>
            <mat-card-title>
              <div id="help" class="float-right"><i class="fa fa-question-circle" aria-hidden="true"></i></div>
            </mat-card-title>
            <app-bread-crumb></app-bread-crumb>
            <img src="assets/images/BienvenidaSplash.png" width="100%" height="30%" />
        </mat-card>
    </div>
  </div>
</div>



